import React from "react";
import { CodeSnippet, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  /**
   * If provided, may be shown in the UI in non-production environments
   */
  error?: Error;
}

const ErrorFallback = ({ error }: Props) => {
  const isNonProduction = process.env.REACT_APP_MERGE_ENV !== "PRODUCTION";
  const errorText = error ? `${error.message}\n\n${error.stack ?? "No stack trace"}` : "";

  return (
    <div className="flex min-h-[calc(100vh-100px)] items-center justify-center">
      <div className="flex flex-col items-center text-center">
        <Text variant="h4" className="tracking-widest text-gray-20">
          ERROR
        </Text>
        <Text variant="h3" className="mt-3">
          Something went wrong
        </Text>
        <Text className="mt-2 text-gray-40">
          {isNonProduction && error
            ? "Error details appear below and in your console"
            : "Please refresh your browser or try again later"}
        </Text>
        {isNonProduction && error && (
          <div className="mt-6 max-h-[60vh] w-full max-w-2xl overflow-auto text-left">
            <CodeSnippet title="Stack trace" showCopyButton>
              {errorText}
            </CodeSnippet>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
